module.exports = __webpack_public_path__ + "static/banner-12-3f4c1edd90a6228a4e16ca1b40064464.jpg";